import {IRouletteBet} from "./IRouletteBet";

export class LowHighNumbersBet implements IRouletteBet {
    constructor(public lowNumbers: boolean, public betAmount: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/betTypes/LowHighNumbersBet.ts